import React, { useRef, useState } from 'react';
import packageJson from '../package.json';
import { SWITCHER_FAMILIES } from './families';

const TREE_BG = `
  url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23228B22' fill-opacity='0.4'%3E%3Crect x='35' y='10' width='10' height='10'/%3E%3Crect x='30' y='20' width='20' height='10'/%3E%3Crect x='25' y='30' width='30' height='10'/%3E%3Crect x='20' y='40' width='40' height='10'/%3E%3Crect x='35' y='50' width='10' height='10'/%3E%3C/g%3E%3Cg fill='%23DC143C' fill-opacity='0.3'%3E%3Crect x='5' y='5' width='5' height='5'/%3E%3Crect x='70' y='15' width='5' height='5'/%3E%3Crect x='10' y='65' width='5' height='5'/%3E%3C/g%3E%3Cg fill='%23FFD700' fill-opacity='0.5'%3E%3Crect x='35' y='5' width='10' height='5'/%3E%3C/g%3E%3C/svg%3E"),
  repeating-linear-gradient(0deg, transparent, transparent 4px, rgba(255, 255, 255, 0.02) 4px, rgba(255, 255, 255, 0.02) 8px)
`;

// Green Christmas-tree background used by the landing / login screens.
export function Backdrop({ children }) {
  return (
    <div className="min-h-screen p-4 sm:p-8" style={{
      backgroundColor: '#1a472a',
      backgroundImage: TREE_BG,
      backgroundSize: '80px 80px, 8px 8px'
    }}>
      <div className="fixed inset-0 pointer-events-none" style={{
        backgroundImage: 'repeating-linear-gradient(90deg, transparent, transparent 4px, rgba(255, 255, 255, 0.02) 4px, rgba(255, 255, 255, 0.02) 8px)',
        backgroundSize: '8px 8px'
      }}></div>
      <div className="max-w-md mx-auto relative z-10">
        {children}
      </div>
    </div>
  );
}

export function Footer() {
  return (
    <div className="mt-8 bg-white rounded-lg shadow-lg py-8 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-4">
          <h3 className="text-2xl font-bold text-gray-800 mb-2">
            🎮 Big Daddy Jeff LLC 🎮
          </h3>
          <p className="text-gray-600 text-sm mb-2">
            Making holiday gift coordination radical since 2024
          </p>
        </div>

        <div className="flex justify-center items-center space-x-4 text-gray-600 text-xs flex-wrap">
          <span>🎄 Built with ❤️ for the family</span>
          <span>•</span>
          <span>Powered by nostalgia & Claude 🤖</span>
        </div>

        <div className="mt-4 text-gray-500 text-xs">
          <p>© 2024 Big Daddy Jeff LLC</p>
          <p className="mt-1">All gifts reserved. No peeking at claimed presents! 🎅</p>
          <p className="mt-2 text-gray-400">v{packageJson.version}</p>
        </div>
      </div>
    </div>
  );
}

// Easter egg: double-click / double-tap the icon to switch between families.
export function FamilySwitcher({ children, currentCode }) {
  const [open, setOpen] = useState(false);
  const lastTap = useRef(0);

  const tap = () => {
    const now = Date.now();
    if (now - lastTap.current < 400) {
      lastTap.current = 0;
      setOpen(o => !o);
    } else {
      lastTap.current = now;
    }
  };

  return (
    <span className="relative inline-block">
      <span
        onClick={tap}
        className="inline-block select-none"
        style={{ touchAction: 'manipulation' }}
      >
        {children}
      </span>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)}></div>
          <div className="absolute left-1/2 -translate-x-1/2 sm:left-0 sm:translate-x-0 top-full mt-2 z-50 w-64 max-w-[80vw] bg-white rounded-lg shadow-xl border border-gray-200 p-3 text-left">
            <p className="text-sm font-semibold text-gray-800 mb-2">Switch family</p>
            <ul className="space-y-1">
              {SWITCHER_FAMILIES.map(({ code, name }) => (
                <li key={code}>
                  <a
                    href={`/f/${code}`}
                    className={`block px-3 py-2 rounded-lg text-sm truncate ${
                      code === currentCode
                        ? 'bg-red-50 text-red-600 font-medium'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`}
                  >
                    {name}{code === currentCode ? ' (current)' : ''}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </span>
  );
}
